const mutations = {
  setMetadado(state, { owner, metadado }) {
    if (state.hasOwnProperty(owner)) {
      state[owner] = metadado;
    }
  },
};

const actions = {
  setMetadado({ commit }, { owner, resource, params = null }) {
    if (owner && resource) {
      resource(params)
        .then((res) => {
          const metadado = res.body;
          commit('setMetadado', { owner, metadado });
        });
        // .catch((err) => {});
    }
  },
  setClienteMetadado({ commit }, { resource, params }) {
    actions.setMetadado({ commit }, {
      owner: 'cliente',
      resource,
      params,
    });
    // commit('setMetadado', 'cliente', metadado);
  },
  setProdutoMetadado({ commit }, { resource, params }) {
    actions.setMetadado({ commit }, {
      owner: 'produto',
      resource,
      params,
    });
  },
};

const getters = {
  getClienteMetadado(state) {
    return state.cliente;
  },
  getProdutoMetadado(state) {
    return state.produto;
  },
};

const state = {
  cliente: null,
  produto: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/metadados.js